<template>
    <div>
        <input
            type="file"
            :disabled="isSaving"
            ref="upload"
            v-if="uploadReady"
            @change="filesChange($event)"
        />
        <document-edit-modal
            v-on="$listeners"
            v-if="file"
            :show-modal.sync="showEditModal"
            :file="file"
        />
    </div>
</template>

<script>
    import FileUpdate from './file-update';
    import DocumentEditModal from "./document-edit-modal"

    const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

    export default {
        components: { DocumentEditModal },
        mixins: [FileUpdate],
        name: "file-upload",
        data() {
            return {
                uploadReady: true,
                currentStatus: null,
                uploadError: null,
                uploadedFiles: [],
                showEditModal: false,
                file: null
            }
        },
        props: {
            entityType: {
                type: String,
                required: false,
            },
            entityId: {
                type: Number,
                required: false,
            },
            documentTypeId: {
                type: Number,
                required: false,
                default: null,
            },
            documentId: {
                type: Number,
                required: false,
                default: null,
            },
            allowDescription: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            isInitial() {
                return this.currentStatus === STATUS_INITIAL;
            },
            isSaving() {
                return this.currentStatus === STATUS_SAVING;
            },
            isSuccess() {
                return this.currentStatus === STATUS_SUCCESS;
            },
            isFailed() {
                return this.currentStatus === STATUS_FAILED;
            }
        },
        methods: {
            getPostUrl() {
                // Routes available when uploading a file to an entity
                if(this.entityType && this.entityId) {
                    if(this.documentTypeId) {
                        return route('resource.document_type.update', {
                            'resource': this.entityType,
                            'resource_id': this.entityId,
                            'document_type': this.documentTypeId,
                        })
                    }

                    if(this.documentId) {
                        return route('resource.files.update', {
                            'resource': this.entityType,
                            'resource_id': this.entityId,
                            'file': this.documentId,
                        })
                    }

                    return route('resource.files.update', {
                        'resource': this.entityType,
                        'resource_id': this.entityId,
                    })
                }

                // When not uploading to a specific entry
                return route('files.store')
            },

            reset() {
                // reset form to initial state
                this.currentStatus = STATUS_INITIAL
                this.uploadedFiles = []
                this.uploadError = null
                this.uploadReady = false
                this.$nextTick(() => {
                    this.uploadReady = true
                })
            },
            save(formData) {
                // upload data to the server
                this.currentStatus = STATUS_SAVING;
                window.axios.post(this.getPostUrl(), formData)
                    .then(response => {
                        this.$emit('uploadSuccess', response.data, this.documentTypeId);
                        this.currentStatus = STATUS_SUCCESS;

                        this.file = response.data
                        this.showEditModal = true
                    }).catch(error => {
                        if (error.response.status === 413) {
                            this.$emit('uploadFailed', [ uLang('app.the_file_is_to_big_for_the_server_to_handle') ]);
                        } else {
                            this.$emit('uploadFailed', error.response.data.errors.file);
                        }

                        this.currentStatus = STATUS_FAILED;
                    }).finally(() => {
                        this.reset();
                    });
            },
            filesChange($event) {
                // handle file changes
                const formData = new FormData();
                let fileList = $event.target.files;

                if (!fileList.length || fileList.length > 1) return;

                // append the files to FormData
                Array
                    .from(Array(fileList.length).keys())
                    .map(x => {
                        formData.append('file', fileList[x], fileList[x].name);
                    });

                // save it
                this.save(formData);
            },
            onFileMetaDataUpdated(file) {
                this.$emit('updateSuccess', file);
            }
        },
        mounted() {
            this.reset();
        },
    }
</script>

<style scoped>

</style>
